import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Line, { x1: "5", x2: "19", y1: "12", y2: "12", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Minus";
const Minus = memo(themed(Icon));
export {
  Minus
};
//# sourceMappingURL=minus.js.map
